<div class="dialogue-content">
    <div class="mat-dialogue-header">
      <h4 class="mat-dialog-title previewHeading" id="modal-basic-title">Confirm to Unfreeze</h4>
      <button type="button" class="btn-close" aria-label="Close" [mat-dialog-close]="false"></button>
    </div>
    <mat-dialog-content class="">
      <p class="confirmation" >Are you sure want to unfreeze selected session of instructor(s) ?</p>
    </mat-dialog-content>
    <div mat-dialog-actions class="dialog-actions dialogue-footer text-center mb-3">
      <button class="btn btn-primary-outline" [mat-dialog-close]="true"  >Yes</button>
      <button class="btn btn-primary" [mat-dialog-close]="false">Cancel</button>
    </div>
  </div>
  
  
  